import { Route, Routes } from "react-router-dom";

import {BrandingLink } from "../../pages";

export const BrandingLinkLayout = () =>{
  return (
    <Routes>
    <Route path="/" element={<BrandingLink/>} />
  </Routes>
  )
}

    
  
